import { Model } from 'shared/services/api/models/Model'
import { NotepadProduct } from './notepadProduct'

export interface NotepadEntriesResponseV1 {
  entries: NotepadProduct[]
  totalCount: number
  limit: number
  page: number
}

export class NotepadEntriesResponse extends Model {
  public entries: NotepadProduct[]
  public totalCount: number
  public limit: number
  public page: number
  constructor(src: NotepadEntriesResponseV1) {
    super(src)
    this.entries = src.entries?.length
      ? src.entries.map((entry: NotepadProduct) => new NotepadProduct(entry))
      : []
    this.limit = src.limit
    this.page = src.page
    this.totalCount = src.totalCount
  }
}
